//import { axios } from '@/api';
import Axios from 'axios';
import store from '@/store'
import http from "..";
import router from '@/router'


class SeguridadService {
  
  centroCostoListar(params) {
    return http.get("/contabilidad/centroCostoListar", { params })
    .catch((error) => { 
      if (error.response.status == 403) {
        store.commit("setUserData", { id: 0, userName: "", IsAutenticated: false });
        router.push('/pages/login').catch(error => {
        if (error.name != 'NavigationDuplicated') {
          throw error
        }
      });
      } 
    });
  }  

  otrosMovimientosListar(params) {
    return http.get("/contabilidad/otrosMovimientosListar", { params })
    .catch((error) => { 
      if (error.response.status == 403) {
        store.commit("setUserData", { id: 0, userName: "", IsAutenticated: false });
        router.push('/pages/login').catch(error => {
        if (error.name != 'NavigationDuplicated') {
          throw error
        }
      });
      } 
    });
  }  
  otrosMovimientosActualizar(data) {
    return http.post("/contabilidad/otrosMovimientosActualizar", data)
    .catch((error) => { 
      if (error.response.status == 403) {
        store.commit("setUserData", { id: 0, userName: "", IsAutenticated: false });
        router.push('/pages/login').catch(error => {
        if (error.name != 'NavigationDuplicated') {
          throw error
        }
      });
      } 
    });
  } 
  centroCostoNuevo(data) {
    return http.post("/contabilidad/centroCostoNuevo", data)
    .catch((error) => { 
      if (error.response.status == 403) {
        store.commit("setUserData", { id: 0, userName: "", IsAutenticated: false });
        router.push('/pages/login').catch(error => {
        if (error.name != 'NavigationDuplicated') {
          throw error
        }
      });
      } 
    });
  } 
  cuentaContableListar(params) {
    return http.get("/contabilidad/cuentaContableListar", { params })
    .catch((error) => { 
      if (error.response.status == 403) {
        store.commit("setUserData", { id: 0, userName: "", IsAutenticated: false });
        router.push('/pages/login').catch(error => {
        if (error.name != 'NavigationDuplicated') {
          throw error
        }
      });
      } 
    });
  }  

  cuentaContableCodigoConsultar(params) {
    return http.get("/contabilidad/cuentaContableCodigoConsultar", { params })
    .catch((error) => { 
      if (error.response.status == 403) {
        store.commit("setUserData", { id: 0, userName: "", IsAutenticated: false });
        router.push('/pages/login').catch(error => {
        if (error.name != 'NavigationDuplicated') {
          throw error
        }
      });
      } 
    });
  }
  
  cuentaContableNuevo(data) {
    return http.post("/contabilidad/cuentaContableNuevo", data)
    .catch((error) => { 
      if (error.response.status == 403) {
        store.commit("setUserData", { id: 0, userName: "", IsAutenticated: false });
        router.push('/pages/login').catch(error => {
        if (error.name != 'NavigationDuplicated') {
          throw error
        }
      });
      } 
    });
  } 

  
  reporteFlujoCajaGeneral(params) {
    return http.get("/contabilidad/reporteFlujoCajaGeneral", { params })
    .catch((error) => { 
      if (error.response.status == 403) {
        store.commit("setUserData", { id: 0, userName: "", IsAutenticated: false });
        router.push('/pages/login').catch(error => {
        if (error.name != 'NavigationDuplicated') {
          throw error
        }
      });
      } 
    });
  }
  
  

}


export default new SeguridadService();